// src/pages/Health/api.js
// Слой доступа к данным раздела «Здравоохранение» (АРМ, UC.05.02).
// Паттерн проекта: getNetwork() (axios с токеном + 401-перехватчик) и API_ROOT.
//
//   GET  /api/health/meta          → { indicators: [...] }              (RQ.09.06)
//   GET  /api/health/indicators    → { rows: [...] }                    (ОС шаг 2)
//   POST /api/health/indicators    → 201 + созданная запись             (RQ.09.03, JSON)
//        422 → { fields: { имя_поля: 'сообщение', ... } }               (АС2, RQ.09.04)
//        409 → дубль периода по показателю                              (АС3, RQ.09.05)

import { getNetwork } from '../../utils/getNetwork';
import { API_ROOT } from '../../config';
import { META, MOCK_ROWS, isDuplicate } from './mockData';

// Пока бэкенда нет — true (данные в памяти). Когда появится — false.
export const USE_MOCK = true;

// Пути операций. Если бэкенд отдаётся под префиксом (напр. /api/v1) — впишите
// его целиком, чтобы совпадало со Swagger. Полный URL = API_ROOT + путь.
const META_ENDPOINT = '/api/health/meta';
const LIST_ENDPOINT = '/api/health/indicators';

export class ApiError extends Error {
  constructor(status, body) {
    super('api_error');
    this.status = status;
    this.body = body;
  }
}

/* ------------------------------ Справочник ------------------------------ */
export async function fetchHealthMeta() {
  if (USE_MOCK) {
    return wait(200).then(() => META);
  }
  const res = await getNetwork().get(API_ROOT + META_ENDPOINT);
  return res.data;
}

/* ------------------------------- Перечень ------------------------------- */
export async function fetchHealthRows() {
  if (USE_MOCK) {
    return wait(300).then(() => ({ rows: mockStore.slice() }));
  }
  const res = await getNetwork().get(API_ROOT + LIST_ENDPOINT);
  return res.data;
}

/* ------------------------------- Создание ------------------------------- */
// payload: { indicator_code, period_type, year, quarter|null, plan, fact, note|null }
export async function createHealthRow(payload) {
  if (USE_MOCK) {
    return mockCreate(payload);
  }
  try {
    const res = await getNetwork().post(API_ROOT + LIST_ENDPOINT, payload);
    // Перехватчик getNetwork при 4xx/5xx возвращает response (не бросает).
    if (res && res.status === 201) return res.data;
    if (res) throw new ApiError(res.status, res.data);
    throw new ApiError(0, null);
  } catch (e) {
    if (e instanceof ApiError) throw e;
    // Сетевой сбой / иное
    throw new ApiError((e.response && e.response.status) || 0, e.response && e.response.data);
  }
}

/* --------------------------------- Мок ---------------------------------- */
let mockStore = MOCK_ROWS.slice();
let seq = Math.max(...MOCK_ROWS.map((r) => r.id)) + 1;

function mockCreate(payload) {
  return wait(350).then(() => {
    if (isDuplicate(mockStore, payload)) {
      throw new ApiError(409, { message: 'duplicate_period' }); // АС3
    }
    const created = { id: seq++, ...payload };
    mockStore = [created, ...mockStore];
    return created;
  });
}

function wait(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
